module.exports = __webpack_public_path__ + "static/img/brand_back_yihao.1097d4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/brand_back_yihao.png
// module id = yZ7F
// module chunks = 1